import { AccordionComponent } from '@dapp/multi-lib/legacy/accordion';
import React, { useState } from 'react';
import Image from 'next/image';
import { Tiny1, Tiny2, Title1, Title2 } from 'components/Typography';
import { useTranslation } from 'react-i18next';
import { Button } from '@dapp/multi-lib/sdaoui/Button';
import { ChevronDown } from 'baseui/icon';
import { headerStatus } from 'interfaces/header-status.enum';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EcoSystemCardMobile = ({ cardData, title }: any) => {
  const { t } = useTranslation('ecosystem');
  const [visibleCount, setVisibleCount] = useState(5);
  const displayedCards = cardData.slice(0, visibleCount);
  const handleCardPagination = () => {
    setVisibleCount(visibleCount + 5);
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const panelList = displayedCards?.map((item: any, index: number) => ({
    title: (
      <>
        <div className='flex w-full items-start gap-3'>
          <Image
            alt='SDAO'
            src={item.logo}
            className='h-16 w-16 rounded-full bg-black-900 p-2'
            height={80}
            width={80}
          />
          <div className='w-full'>
            <Title1 className='text-white'>{item.title}</Title1>
            <div className='flex items-center justify-between'>
              <Tiny2 className='font-light text-mono-100'>
                {item.description}
              </Tiny2>
              <div className='text-nowrap'>
                {item.status === 'COMING_SOON' ? (
                  <Tiny1 className=' text-positive-800'>
                    {t('common:LINK_STATUS.' + headerStatus.COMING_SOON)}
                  </Tiny1>
                ) : (
                  <Button
                    className='px-2 py-1 text-xs font-normal'
                    onClick={() => {
                      window.open(item.Link, '_blank');
                    }}
                  >
                    {t('VIEW')}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    ),
    key: `panel-${index}`,
    content: <Tiny2 className='text-white-500'>{item.backDetails}</Tiny2>,
  }));

  return (
    <>
      <AccordionComponent
        overrides={{
          Header: {
            style: ({ $theme }) => ({
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              fontWeight: 600,
              fontSize: $theme.sizing.scale600,
              letterSpacing: '0.2px',
            }),
          },
          PanelContainer: {
            style: ({ $theme }) => ({
              borderTopWidth: '0.5px',
              borderTopColor: '#B5B5B5',
              borderBottomWidth: '0.5px',
              borderBottomColor: '#B5B5B5',
              borderLeftWidth: '0.5px',
              borderLeftColor: '#B5B5B5',
              borderRightWidth: '0.5px',
              borderRightColor: '#B5B5B5',
              marginBottom: '16px',
              position: 'relative',
            }),
          },
          Content: {
            style: () => ({
              paddingTop: '0px',
              paddingBottom: '16px',
              backgroundColor: 'transparent',
            }),
          },
          ToggleIcon: {
            component: ({ $expanded }: { $expanded: boolean }) => (
              <div
                style={{
                  position: 'absolute',
                  top: '16px',
                  right: '12px',
                  transform: $expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
              >
                <ChevronDown size={20} color='#ffffff' />
              </div>
            ),
          },
        }}
        panelList={panelList}
        iconSet={{
          upwards: 'expand_less',
          downwards: 'expand_more',
          fillColor: '#808080',
        }}
      />
      {displayedCards?.length < cardData.length && (
        <div className={'flex justify-center'}>
          <button
            onClick={handleCardPagination}
            className='bg-[linear-gradient(102.69deg,_#151518 0%,_#0E0E13 100%)] mb-2.5 flex rounded-full border-[0.4px] border-mono-100 px-3 py-1 hover:border-[0.2px] hover:bg-[linear-gradient(103deg,_#363636_0%,_#1A1A1A_100%)] lg:hidden'
          >
            <Title2 className='font-normal text-white'>{t('SHOW_MORE')}</Title2>
          </button>
        </div>
      )}
    </>
  );
};
